import type { Contact } from '../../../../domain/contact';
import { useDispatchTrackEventWithLocation } from '../../../../services/tracking/hooks/useDispatchTrackEventWithLocation';
import TrackingContactsService from '../../../../services/tracking/TrackingContactsService';

export const useContactRevealTracking = () => {
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();

  const handleTrackRevealClick = (contact: Contact) => {
    dispatchTrackEventWithLocation(
      'person data',
      'click reveal',
      `reveal contact/${TrackingContactsService.getAvailableContactDetails(contact)}/${contact.title}`
    );
  };

  const handleUpgradeToRevealClick = (contact: Contact) => {
    dispatchTrackEventWithLocation(
      'hooks',
      'upgrade package',
      `reveal contact/${TrackingContactsService.getAvailableContactDetails(contact)}/${contact.title}`
    );
  };

  const handleTrackRevealFinish = ({ isSuccessful }: { isSuccessful: boolean }) => {
    const eventName = isSuccessful ? 'revealed successfully' : 'revealed failure';
    dispatchTrackEventWithLocation('contacts', eventName, 'single reveal/1/1');
  };

  return {
    handleTrackRevealClick,
    handleUpgradeToRevealClick,
    handleTrackRevealFinish,
  };
};
